import * as types from "./types";

const fetchDetailsStart = () => ({
   type: types.FETCH_DETAILS_START,
});
const fetchDetailsCompleted = (data) => {
   return {
      type: types.FETCH_DETAILS_COMPLETED,
      payload: data,
   }
};
const clearState = (payload) => ({
   type: types.CLEAR_STATE,
   payload,
})
const fetchDetailsFailed = (err) => ({
   type: types.FETCH_DETAILS_FAILED,
   payload: err,
});
const fetchNextDetailsStart = () => ({
   type: types.FETCH_NEXT_DETAILS_START,
});
const fetchNextDetailsCompleted = (data) => {
   return {
      type: types.FETCH_NEXT_DETAILS_COMPLETED,
      payload: data,
   }
};
const fetchNextDetailsFailed = (err) => ({
   type: types.FETCH_NEXT_DETAILS_FAILED,
   payload: err,
});

const fetchRequestByFilter = () => ({
   type: types.FETCH_BY_FILTER_DETAILS_START,
});
const fetchRequestByFilterCompleted = (data, isClearFilters) => ({
   type: types.FETCH_BY_FILTER_DETAILS_COMPLETED,
   payload: { data, isClearFilters },
})

const fetchRequestByFilterFailed = (err) => ({
   type: types.FETCH_BY_FILTER_DETAILS_FAILED,
   payload: err,
})

const fetchCategoriesCompleted = (data) => ({
   type: types.FETCH_CATEGORIES_COMPLETED,
   payload: data,
})

const fetchDataByFilters = () => ({
   type: types.FETCH_DATA_BY_FILTERS,
})

const updateStoreListAction = (data, actionType) => ({
   type: types.UPDATE_STORE_LIST,
   payload: { data, actionType },
})

const toggleLikeCompleted = (id, type) => ({
   type: types.TOGGLE_LIKE_COMPLETED,
   payload: { id, type },
})

const toggleWatchedCompleted = (id, type) => ({
   type: types.TOGGLE_WATCHED_COMPLETED,
   payload: { id, type },
})

const onChangeFavoriteItemCompleted = (id, type, isFiltered) => ({
   type: types.ON_CHANGE_FAVORITE_ITEM_COMPLETED,
   payload: { id, type, isFiltered },
});

export {
   fetchDetailsStart,
   fetchDetailsFailed,
   fetchDetailsCompleted,
   clearState,
   fetchRequestByFilter,
   fetchRequestByFilterCompleted,
   fetchRequestByFilterFailed,
   fetchNextDetailsStart,
   fetchNextDetailsCompleted,
   fetchNextDetailsFailed,
   fetchCategoriesCompleted,
   fetchDataByFilters,
   updateStoreListAction,
   toggleLikeCompleted,
   toggleWatchedCompleted,
   onChangeFavoriteItemCompleted,
};
